<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>公司</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="公司编号:" prop="code">
                          <el-input
                            id="code"
                            :disabled="IsReadonlyCode"
                            v-model="SelectData.code"
                            clearable
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="公司名称:" prop="name">
                          <el-input
                            id="name"
                            v-model="SelectData.name"
                            clearable
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="公司状态:" prop="status">
                          <el-switch
                            id="status"
                            v-model="SelectData.status"
                            size="large"
                            active-text="启用"
                            inactive-text="禁用"
                            :disabled="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="是否平台方:" prop="isPlatform">
                          <el-switch
                            id="isPlatform"
                            v-model="SelectData.isPlatform"
                            size="large"
                            active-text="是"
                            inactive-text="否"
                            :disabled="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import {
  SelectCompanyById,
  ModifyCompany,
  AddCompany,
} from "@api/Company/ApiCompany";

export default {
  name: "CompanyEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      SelectData: {},
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
    };
  },

  created() {},
  mounted() {},
  methods: {
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(id, type) {
      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;
      _this.IsReadonlyCode=true;

      if (type == "Add") {
        _this.IsReadonlyCode = false;
        _this.SelectData = {};
        return;
      } else if (type == "Detail") {
        _this.IsReadonly = true;
        _this.IsShowConfirm = false;
      }
      SelectCompanyById(id).then(function (data) {
        _this.SelectData = data;
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    handleConfirm() {
      var _this = this;
      if(!_this.validate())return;
      if (_this.OpStatus == "Add") {
        AddCompany(this.SelectData).then(function (data) {
          _this.$message.success("保存成功!");
          _this.$emit("handle-confirm");
        }).catch(err => {
          _this.$message.error(err.message);
        });
      } else if (_this.OpStatus == "Modify") {
        ModifyCompany(this.SelectData).then(function (data) {
          _this.$message.success("修改成功!");
          _this.$emit("handle-confirm");
        }).catch(err => {
          _this.$message.error(err.message);
        });
      }
    },
    validate() {
      if (!this.SelectData.code || this.SelectData.code == "") {
        this.$message.error("公司编号是必须的!");
        return false;
      }
      if (!this.SelectData.name || this.SelectData.name == "") {
        this.$message.error("公司名称是必须的!");
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped >
.select-items {
  position: relative;
  display: flex;
}

.select-item {
  height: 50px;
  flex: 33.33%;
  display: flex;
  margin: 0 10px;
}
.item-lab {
  flex: 25%;
  line-height: 50px;
  display: flex;
  position: relative;
}

.item-input {
  flex: 75%;
}

.item-lab > label {
  align-items: flex-end;
  position: absolute;
  right: 5px;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
